export default "###### Carma's details:\n\n<strong> Phone number: </strong> 02 8319 3210 </br>\n<strong> Email address: </strong> hello@carma.com.au\n";